export async function readFileData(file) {
  if (file) {
    let result_text = await new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.readAsText(file, 'UTF-8');
      fileReader.onload = (e) => resolve(e.target.result);
      fileReader.onerror = (e) => reject(e);
    });
    return result_text;
  }
  return null;
}
